import React, { useContext, useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import { Module, RouteType } from "./types";
import { Context } from "@modules/sections/GroupsManager/context/GroupsManagerContext";
import { GeneralTypes } from "@modules/sections/GroupsManager/context/general.reducer";

interface GroupsManagerLayoutProps {
  groupsManagerModule: Module;
}

const GroupsManagerLayout = ({ groupsManagerModule }: GroupsManagerLayoutProps) => {
  const { dispatch } = useContext(Context);

  useEffect(() => {
    window.addEventListener("reset-groups-manager", () => {
      dispatch({ type: GeneralTypes.ResetGroupsManager });
    });

    return () => {
      window.removeEventListener("reset-groups-manager", () => {
        dispatch({ type: GeneralTypes.ResetGroupsManager });
      });
    };
  }, []);

  return (
    <Switch>
      {groupsManagerModule?.routes?.map((route: RouteType) => (
        <Route key={route?.path} path={route?.path} component={route?.component} />
      ))}
    </Switch>
  );
};

export default GroupsManagerLayout;
